import { Controller } from '@hotwired/stimulus';

const originalParents = new WeakMap();

export default class extends Controller {
  connect() {
    const openButtons = this.element.querySelectorAll('.open-modal');
    const closeButtons = this.element.querySelectorAll('.close-modal');
    
    openButtons.forEach(button => {
      button.addEventListener('click', this.openModal.bind(this));
    });
    
    closeButtons.forEach(button => {
      button.addEventListener('click', this.closeModal.bind(this));
    });
    
    this.clickHandler = this.handleDocumentClick.bind(this);
    document.addEventListener('click', this.clickHandler);
    
    this.keyHandler = this.handleKeyDown.bind(this);
    document.addEventListener('keydown', this.keyHandler);
  }
  
  disconnect() {
    document.removeEventListener('click', this.clickHandler);
    document.removeEventListener('keydown', this.keyHandler);
  }
  
  handleDocumentClick(event) {
    const modals = document.querySelectorAll('.modal');
    modals.forEach(modal => {
      if (event.target === modal) {
        this.closeSpecificModal(modal);
      }
    });
  }
  
  handleKeyDown(event) {
    if (event.key === 'Escape') {
      const openModals = document.querySelectorAll('.modal:not(.hidden)');
      openModals.forEach(modal => {
        this.closeSpecificModal(modal);
      });
    }
  }

  openModal(event) {
    const button = event.currentTarget;
    const modalId = button.dataset.modalId;
    const modal = document.getElementById(modalId);
    
    if (modal) {
      if (modal.parentElement !== document.body) {
        originalParents.set(modal, modal.parentElement);
        document.body.appendChild(modal);
      }
      
      modal.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
    }
  }

  closeModal(event) {
    event.stopPropagation();
    const button = event.currentTarget;
    const modal = button.closest('.modal');
    
    if (modal) {
      this.closeSpecificModal(modal);
    }
  }

  closeSpecificModal(modal) {
    modal.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');

    if (originalParents.has(modal)) {
      const originalParent = originalParents.get(modal);
      if (originalParent) {
        originalParent.appendChild(modal);
      }
      originalParents.delete(modal);
    }
  }
}
